import React from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import SalarySlip from "../../User/SalarySlip/SalarySlip";

const ClientPaySlipDetail = () => {
  const { employeeId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const month = Number(searchParams.get("month"));
  const year = Number(searchParams.get("year"));

  const monthIndex = Number.isFinite(month) ? month - 1 : undefined;

  return (
    <div className="container py-4">
      <div className="d-flex mb-3 justify-content-between align-items-center">
        <div>
          <h4>Employee Pay Slip</h4>
          <p className="text-muted mb-0">Employee ID: {employeeId}</p>
        </div>
        <Button variant="outline-secondary" size="sm" onClick={() => navigate("/client_dashboard/pay-slip")}>
          Back to Pay Slips
        </Button>
      </div>
      <SalarySlip employeeId={employeeId} externalMonth={monthIndex} externalYear={year} />
    </div>
  );
};

export default ClientPaySlipDetail;
